var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnestroiScBlockchainEos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.171,
    height: 60.499,
    viewBox: "0 0 40.171 60.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e8ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#075485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#064c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012043"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31669",
    "data-name": "Path 31669",
    d: "M20.085,0,5.929,19.48,0,48.278,20.085,60.5,40.171,48.278l-6.05-28.918ZM3.267,46.947l4.477-21.9L17.907,55.9ZM9.2,20.085l10.89-15,10.89,15L20.085,53ZM22.142,55.9,32.306,25.046l4.477,21.9Z",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnestroiScBlockchainEos);
export default __webpack_public_path__ + "static/media/earnestroi-sc-blockchain-EOS.338818375afabcd007dff25bd72c07f0.svg";
export { ForwardRef as ReactComponent };